<template>
  <div>
    <h1 class="is-size-4">Giochi</h1>



    <div class="columns">
      <div class="column is-half">
        <b-field label="Titolo">
          <b-input ref="iTitolo" v-model="filterModel.Title" tabindex="1"></b-input>
        </b-field>

        <b-field label="Lo stavo giocando in data">
          <b-datepicker ref="iDateBegin" v-model="filterModel.PlayDateRange" editable :date-formatter="isoDate">
          </b-datepicker>
        </b-field>


        <b-field label="Stato">
          <b-select ref="iSeasonStatus" v-model="filterModel.StatusId">
            <option v-for="x in lovs.gameStatus" :value="x.Id" :key="x.Id">
              {{ x.GameStatus }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Commenti">
          <b-input type="textarea" v-model="filterModel.Comment"></b-input>
        </b-field>

      </div>

      <div class="column">
        <b-field label="Titolo originale">
          <b-input ref="iTitoloOr" v-model="filterModel.OriginalTitle" tabindex="2"></b-input>
        </b-field>

        <b-field label="Anno acquisizione">
          <b-input ref="iAnnoFine" v-model="filterModel.PurchaseYear" type="number" min="1800" max="2100" tabindex="4">
          </b-input>
        </b-field>

        
        <b-field label="Piattaforma">
          <b-select ref="iSeasonStatus" v-model="filterModel.PlatformId">
            <option v-for="x in lovs.platform" :value="x.Id" :key="x.Id">
              {{ x.Platform }}
            </option>
          </b-select>
        </b-field>

        <b-field label="Voto">
          <star-rating v-model="filterModel.Dicks" :show-rating="false" :increment="0.5" :star-size="30" />
        </b-field>

      </div>

    </div>
    <section>
        <div class="buttons">
          <b-button @click="doOkSearch" type="is-primary">Vai</b-button>
          <b-button @click="doClearSearch" type="is-primary"
            >Mastrolindo</b-button
          >
        </div>
      </section>
  </div>
</template>

<script>
import helpers from "../helpers.js";
import api from "../api/api.js";
import StarRating from "vue-star-rating";
let emptyVal = { id: 0, Dicks: 0 };

export default {
  name: "SearchGame",
  components: { StarRating },
  methods: {
 
    isoDate(date) {
      return helpers.buildIsoDate(date);
    },
    doClearSearch() {
      this.filterModel = {};
    },
    doOkSearch() {
      this.$emit("OkSearchGame", this.filterModel);
    },

  },
  data() {
    return {
      selectedRow: null,
      newItem: emptyVal,
      lovs: {platform:[]},
      filterModel: {}
    };
  },
  mounted() {
    const loading = this.$buefy.loading.open();
    if (!this.lovs.gameStatus) 
    {
      api.lovs().then((data) => {

        this.lovs.platform = data.data.platforms;
        this.lovs.gameStatus = data.data.gameStatuses;
        loading.close();
      });
    } else {
      loading.close();
    }

  },
};
</script>

<style></style>
